<div>
  <h4 class="font-app-bold text-darkest">
    {{ "lessorInformations.title" | translate }}
  </h4>
  <div class="flex items-end mt-3">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-xs md:text-base col-start-1">{{
        "lessorInformations.lessorType" | translate
      }}</span>
    </div>
    <span class="text-xs md:text-base font-app-regular text-darkest">{{ lessor.lessorType }}</span>
  </div>
  <div
    class="flex items-end mt-3"
    *ngIf="lessor.lessorType === lessorType.Social">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-xs md:text-base col-start-1">{{
        "lessorInformations.lessorName" | translate
      }}</span>
    </div>
    <span class="text-xs md:text-base font-app-regular text-darkest w-1/3 text-end">{{ lessor.name }}</span>
  </div>
  <div
    class="flex items-end mt-3"
    *ngIf="lessor.lessorType === lessorType.Private">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-xs md:text-base col-start-1">{{
        "lessorInformations.lessorEmail" | translate
      }}</span>
    </div>
    <span
      class="text-xs md:text-base font-app-regular text-darkest w-full text-end overflow-hidden overflow-ellipsis whitespace-nowrap"
      >{{ lessor.email }}</span
    >
  </div>
  <div class="flex items-end mt-3">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-xs md:text-base col-start-1">{{
        "lessorInformations.lessorDate" | translate
      }}</span>
    </div>
    <span
      class="text-xs md:text-base font-app-regular text-darkest w-full text-end overflow-hidden overflow-ellipsis whitespace-nowrap"
      >{{ lessorDateSentTerminationLetter | date: "dd/MM/yyyy" }}</span
    >
  </div>
</div>

